export default __webpack_public_path__ + "static/media/engagement.45249d36.jpg";